import { Injectable } from '@angular/core';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class RegionenUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 're';

  constructor() {
    super(RegionenUrlService.URL_PARAMETER, 're');
  }
}
